export default "__VITE_ASSET__BstN3KWj__"